import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ab6b461"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "ms-top-bar",
  class: "py-2 w-full"
}
const _hoisted_2 = { class: "flex align-items-center gap-2" }
const _hoisted_3 = { class: "flex gap-2 align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "SAWE-T", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "flex gap-2 align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "card flex justify-content-center absolute right-0 z-20 border-1"
}
const _hoisted_9 = { class: "flex align-items-center justify-center gap-1 px-2 py-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, "SAWE-T", -1))
const _hoisted_11 = { class: "text-primary font-bold" }
const _hoisted_12 = { class: "flex align-items-center" }
const _hoisted_13 = { class: "ml-2" }
const _hoisted_14 = {
  key: 1,
  class: "ml-auto border-1 surface-border border-round surface-100 text-xs p-1"
}
const _hoisted_15 = { class: "relative overflow-hidden w-full flex align-items-center p-2 pl-3 text-color border-noround" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-user mr-3",
  style: {"font-size":"1.5rem"}
}, null, -1))
const _hoisted_17 = { class: "inline-flex flex-column" }
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Admin", -1))

import Toolbar from 'primevue/toolbar'
import Menu from 'primevue/menu'
import Badge from 'primevue/badge'
import { computed, type ComputedRef, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { type MenuItem } from 'primevue/menuitem'
import { Auth } from 'aws-amplify'
import Button from 'primevue/button'
import SawetLogo from '@/components/SawetLogo/SawetLogo.vue'
import router from '@/router'
import { useAuthStore } from '@/store/auth.store'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const { t } = useI18n()
const route = useRoute()

let user = ref(null)
let menuOpen = ref(false)
const authStore = useAuthStore()

const sideBarVisible = ref<boolean>(false)

const isActive = (path: string) => {
  // For exact matches
  if (route.path === path) {
    return true
  }

  // For nested routes (if path is a prefix of current route)
  if (path !== '/' && route.path.startsWith(path)) {
    return true
  }

  return false
}

onMounted(async () => {
  user.value = await Auth.currentUserInfo()
})

function menuHandler() {
  menuOpen.value = !menuOpen.value
}

const items: ComputedRef<MenuItem[]> = computed(() => [
  {
    separator: true
  },
  {
    label: 'Help',
    icon: 'pi pi-question-circle',
    command: async () => {
      await router.push({
        name: 'HelpView'
      })
    }
  },
  {
    label: t('menu.user.logout'),
    icon: 'pi pi-sign-out',
    // disabled: logoutLoading.value,
    size: 'small',
    command: () => {
      authStore.logout()
    }
  },
  {
    separator: true
  }
])

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Toolbar), { class: "bg-transparent border-0" }, {
      start: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(SawetLogo, {
              width: 40,
              height: 40
            }),
            _hoisted_4
          ]),
          _createVNode(_component_router_link, {
            to: "/dashboard/safety",
            class: "ml-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                label: "Safety",
                text: "",
                plain: "",
                class: _normalizeClass([
                'font-semibold',
                isActive('/dashboard/safety') ? 'text-primary' : 'text-gray-700'
              ])
              }, null, 8, ["class"])
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/dashboard/wellbeing",
            class: "ml-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                label: "Wellbeing",
                text: "",
                plain: "",
                class: _normalizeClass([
                'font-semibold',
                isActive('/dashboard/wellbeing') ? 'text-primary' : 'text-gray-700'
              ])
              }, null, 8, ["class"])
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/dashboard/signoff",
            class: "ml-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                label: "Sign Off",
                text: "",
                plain: "",
                class: _normalizeClass([
                'font-semibold',
                isActive('/dashboard/signoff') ? 'text-primary' : 'text-gray-700'
              ])
              }, null, 8, ["class"])
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/surveys",
            class: "ml-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                label: "Surveys",
                text: "",
                plain: "",
                class: _normalizeClass(['font-semibold', isActive('/surveys') ? 'text-primary' : 'text-gray-700'])
              }, null, 8, ["class"])
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/about",
            class: "ml-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                label: "About",
                text: "",
                plain: "",
                class: _normalizeClass(['font-semibold', isActive('/about') ? 'text-primary' : 'text-gray-700'])
              }, null, 8, ["class"])
            ]),
            _: 1
          })
        ])
      ]),
      end: _withCtx(() => [
        (_unref(user))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("i", {
                class: "pi pi-align-right cursor-pointer",
                style: {"font-size":"1.5rem"},
                onClick: menuHandler
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_router_link, { to: "/auth" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      label: "Log in",
                      severity: "secondary",
                      text: ""
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/demonstration" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      id: "demo",
                      label: "Book a demo"
                    })
                  ]),
                  _: 1
                })
              ])
            ]))
      ]),
      _: 1
    }),
    (_unref(menuOpen))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_unref(Menu), {
            model: items.value,
            class: "w-full md:w-15rem"
          }, {
            start: _withCtx(() => [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(SawetLogo),
                _hoisted_10
              ])
            ]),
            submenuheader: _withCtx(({ item }) => [
              _createElementVNode("span", _hoisted_11, _toDisplayString(item.label), 1)
            ]),
            item: _withCtx(({ item }) => [
              _createElementVNode("a", _hoisted_12, [
                _createElementVNode("span", {
                  class: _normalizeClass(item.icon)
                }, null, 2),
                _createElementVNode("span", _hoisted_13, _toDisplayString(item.label), 1),
                (item.badge)
                  ? (_openBlock(), _createBlock(_unref(Badge), {
                      key: 0,
                      class: "ml-auto",
                      value: item.badge
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (item.shortcut)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.shortcut), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            end: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("span", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(user) != null ? _unref(user).username : ''), 1),
                  _hoisted_19
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})